export default __webpack_public_path__ + "static/media/16.b9c73cc8.jpeg";